import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-checkbox-field',
  templateUrl: './checkbox-field.component.html',
  styleUrls: ['./checkbox-field.component.scss'],
})
export class CheckboxFieldComponent {
  @Input() hasError = false;
  @Input() center = false;
  @Input() label: string;
  @Input() name: string;
  @Input() id: string;
  @Input() control: AbstractControl;
  @Input() white = false;
  @Input() isIndeterminate = false;

  constructor() {}
}
